<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório rastreio de feridas">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-rastreio-ferida/List'

export default {
    components: { List },
}
</script>